import { combineReducers } from "redux";
import { createItemReducer } from "@mnjsplatform/data/lib/reducers/dataItemReducer";

export default function soutReducer() {
    return combineReducers({
        RateCardSignPers_POx_List: createItemReducer("SoutCards", "RateCardSignPers.POx_List", false),
        RateCardSignPers_POx_SignCard: createItemReducer("SoutCards", "RateCardSignPers.POx_SignCard", false),
        RateCardSignPers_POx_GetCardScan:createItemReducer("SoutCards", "RateCardSignPers.POx_GetCardScan", false),
        RateCardSignPers_POx_UnSignCard: createItemReducer("SoutCards", "RateCardSignPers.POx_UnSignCard", false),
    });
}